import {
  SHOW_CLONE_SETTINGS_MODAL,
  SHOW_CLONE_SETTINGS_MODAL_HIDE,
  CLEAR_REDUX
} from "Redux/actionTypes";

const INIT_STATE = {
  openModal: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case SHOW_CLONE_SETTINGS_MODAL:
      return { ...state, openModal: true };

    case SHOW_CLONE_SETTINGS_MODAL_HIDE:
      return { ...state, openModal: false };

    case CLEAR_REDUX:
      return ["","CLONE_SETTINGS_MODAL"].includes(action.payload.option)
        ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
        : { ...state }
        
    default:
      return state;
  }
};
